import { types } from "../../types/types";

const initialState = {
  cargada: false,
  datosContablesExistentes: null,
  datosCuentaJudicial: null,
  bancos: [],
  categorias: [],
  condicionIva: [],
  cuentas: [],
  loading: false,
};

export const contratacionesDatosContablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesTraerBancosStart:
      return {
        ...state,
        loading: true,
        cargada: false,
      };
    case types.contratacionesTraerBancosSuccess:
      return {
        ...state,
        loading: false,
        bancos: action.payload,
        cargada: true,
      };
    case types.contratacionesTraerBancosError:
      return {
        ...state,
        loading: false,
        bancos: [],
        cargada: false,
      };
    case types.contratacionesTraerCategoriasStart:
      return {
        ...state,
        loading: true,
        cargada: false,
      };
    case types.contratacionesTraerCategoriasSuccess:
      return {
        ...state,
        loading: false,
        categorias: action.payload,
        cargada: true,
      };
    case types.contratacionesTraerCategoriasError:
      return {
        ...state,
        loading: false,
        categorias: [],
        cargada: false,
      };
    case types.contratacionesSetearDatosContables:
      return {
        ...state,
        datosContablesExistentes: action.payload,
      };
      case types.contratacionesContratoLimpiarSeleccion: {
        return {
          ...state,
          datosContablesExistentes: null,
        }
      }
      case types.contratacionIvaTraerStart:
      return {
        ...state,
        loading: true,
        cargada: false,
      };
    case types.contratacionIvaTraerSuccess:
      return {
        ...state,
        loading: false,
        condicionIva: action.payload,
        cargada: true,
      };
    case types.contratacionIvaTraerError:
      return {
        ...state,
        loading: false,
        condicionIva: [],
        cargada: false,
      };
    case types.contratacionesCuentasClean:
      return {
        ...state,
        cuentas: [],
      };
    case types.contratacionesTraerCuentasStart:
      return {
        ...state,
        loading: true,
        cargada: false,
      };
    case types.contratacionesTraerCuentasSuccess:
      return {
        ...state,
        loading: false,
        cuentas: action.payload,
        cargada: true,
      };
    case types.contratacionesTraerCuentasError:
      return {
        ...state,
        loading: false,
        cuentas: [],
        cargada: false,
      };
    case types.contratacionesCuentasGuardar:
      return {
        ...state,
        cuentas: [
          ...state.cuentas,
          action.payload
        ],
      };
    case types.contratacionesCuentasActualizar:
      return {
        ...state,
        cuentas: state.cuentas.map(
          (item) => item.id === action.payload.id
            ? {...item, ...action.payload}
            : item
        )
      };
    case types.contratacionesCuentasEliminar:
      return {
        ...state,
        cuentas: state.cuentas.filter(item => 
          item.id !== action.payload
        ),
      };
    case types.contratacionesCuentaJudicialGet:
      return {
        ...state,
        datosCuentaJudicial: action.payload,
      };
    case types.contratacionesCuentaJudicialClean:
      return {
        ...state,
        datosCuentaJudicial: null,
      };
    case types.contratacionesCuentaJudicialSave:
      return {
        ...state,
        datosCuentaJudicial: {...state.datosContablesExistentes, ...action.payload},
      };
    default:
      return state;
  }
};


export const contratacionesDatosContablesActions = {
  cuentaJudicial: {
    clean: (dispatch) => dispatch(({type: types.contratacionesCuentaJudicialClean})),
    get: (data, dispatch) => dispatch(({type: types.contratacionesCuentaJudicialGet, payload: data})),
    save: (data, dispatch) => dispatch(({type: types.contratacionesCuentaJudicialSave, payload: data})),
  }
}